import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BrowserRouter as Router } from 'react-router-dom';
import ThemeProviderWrapper from './assets/theme';
import store from './state/configureStore';
import './App.css';
import './index.css';
import 'aos/dist/aos.css';
import AOS from 'aos';
import AppContent from './AppContent';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import config from './utils/config/config';

const App = () => {

  useEffect(() => {
    AOS.init({ duration: 500 });
  }, []);

  return (
    <GoogleOAuthProvider clientId={config.googleClientId}>
      <Provider store={store}>
        <ThemeProviderWrapper>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Router>
              <AppContent />
            </Router>
          </LocalizationProvider>
        </ThemeProviderWrapper>
        <ToastContainer />
      </Provider>
    </GoogleOAuthProvider>
  );
};

export default App;
